import React from "react";
import ReactDOM from "react-dom/client";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import PollComponent from "./components/Polling";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
    <Router>
      <Routes>
        <Route path="/poll-component" element={<PollComponent />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        {/* Core (Malayalam.Ai) */}
        <Route path="/admin/core/users" element={<AdminDashboard />} />
        {/* Chatroom Management */}
        <Route path="/admin/chatroom/overview" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/rooms" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/guests" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/guests/fingerprinting" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/user/:username" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/messages" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/username-words" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/ip" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/ip/:ipAddress/users" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/reports" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/bans" element={<AdminDashboard />} />
        <Route path="/admin/chatroom/settings" element={<AdminDashboard />} />
        {/* Content */}
        <Route path="/admin/dashboard/media" element={<AdminDashboard />} />
        <Route path="/admin/dashboard/blog" element={<AdminDashboard />} />
        {/* System */}
        <Route path="/admin/dashboard/database" element={<AdminDashboard />} />
        <Route path="/admin/dashboard/analytics" element={<AdminDashboard />} />
        <Route path="/admin/dashboard/settings" element={<AdminDashboard />} />
        <Route path="*" element={<App />} />
      </Routes>
    </Router>
  </SnackbarProvider>
);
